export default {
  name: 'PromotionModel',

  data () {
    return {
      model: {
        Firstname  : '',
        Lastname   : '',
        Email      : '',
        Phone      : '',
        IsCompany  : 0,
        CompanyName: '',
        ZipCode    : '',
        PlateNumber: '',
        CarId      : null,
        BrandId    : null,
        Terms      : false,
        Privacy    : false,
        GDPR       : {
          Email: 0,
          Phone: 0,
          SMS  : 0,
        }
      },

      validationRules: {
        Firstname  : { required: true, minLen: 2, maxLen: 50, type: 'string' },
        Lastname   : { required: true, minLen: 2, maxLen: 50, type: 'string' },
        Email      : { required: false, type: 'email' },
        Phone      : { required: true, type: 'greekMobilePhone' },
        IsCompany  : { required: true },
        CompanyName: { required: false, minLen: 2, maxLen: 50, type: 'string' },
        ZipCode    : { required: true, length: 5, type: 'string' },
        PlateNumber: { required: true, minLen: 3, maxLen: 8, type: 'string' },
        BrandId    : { required: true },
        CarId      : { required: true },
        Terms      : { required: true, type: 'boolean', equalsValueTerms: v => v === true },
        Privacy    : { required: true, type: 'boolean', equalsValuePrivacy: v => v === true },
      },

      validationErrorMessages: {
        el: {
          equalsValuePrivacy: 'Πρέπει να αποδεχτείτε την Επισήμανση Απορρήτου',
          equalsValueTerms  : 'Πρέπει να αποδεχτείτε τους Όρους της ενέργειας'
        },
        en: {
          equalsValuePrivacy: 'You must accept the terms of the Privacy Notice',
          equalsValueTerms  : 'You must accept the terms of the promotion',
        }
      },

    }
  },

}
